import { CardFace, cardImage, tip } from "./assets.tsx";
import { cardCopy } from "./glossary.ts";
import { cardAccent } from "./themes.ts";
import type { KleinMemoryEntry, PlayerState } from "./types.ts";

export function KleinMemoryCard({ entry, players, labelOf, className }: {
  entry: KleinMemoryEntry;
  players: readonly PlayerState[];
  labelOf: (id: string) => string;
  className: string;
}) {
  const reviewed = cardCopy(entry.card_id);
  const name = reviewed?.name ?? labelOf(entry.card_id);
  const direction = entry.direction === "received" ? "收到" : entry.direction === "drawn" ? "抽得" : "记录";
  const judgment = entry.judgment;
  const giver = judgment && (players.find((player) => player.id === judgment.giver)?.name ?? judgment.giver);
  const receiver = judgment && (players.find((player) => player.id === judgment.receiver)?.name ?? judgment.receiver);
  const handling = judgment
    ? `${giver} → ${receiver}\n${receiver}宣言「${judgment.declaration === "obey" ? "遵从指示" : "什么都不会发生"}」`
    : "未记录处理宣言；仅保留看到的卡面。";
  const observedText = entry.text || reviewed?.effect || "未记录卡面文字。";
  const reviewedMatches = reviewed?.effect === observedText;

  return (
    <figure
      className={className}
      tabIndex={0}
      aria-label={`命莲寺记录：${name} · ${direction}。${handling}。看到的卡面：${observedText}`}
      {...tip({
        title: name,
        kicker: `命莲寺记录 · ${direction} · 仅自己可见`,
        summary: handling,
        detail: reviewedMatches ? undefined : observedText,
        detailLabel: "看到的卡面文字",
        meta: judgment ? "这是收牌者的公开宣言，不代表已核实其身份或是否符合牌面条件。" : undefined,
        metaLabel: "记录说明",
        titleRuns: reviewed?.nameRuns,
        reviewLines: reviewedMatches ? reviewed?.lines : undefined,
        image: cardImage(entry.card_id) ?? undefined,
        color: cardAccent(entry.card_id),
        layout: "card",
      })}
    >
      <CardFace id={entry.card_id} alt="" />
      <figcaption>{direction}</figcaption>
    </figure>
  );
}
